


<div *ngIf="authLevel" class=autoReplies [@auto]=autoReplyTrigger>
  <div class=autoReplyInputs>
    <p>Common replies are messages you may need to send to more than one individual at different times, i.e. a welcome message.  Add these customized messages below so save time later on when sending to multiple people  </p>
    <textarea  matInput class="reply-input" name="autoReplyBody" [(ngModel)]="autoReplyBody" placeholder="Example: Welcome to our Bible school.  Don't be afraid to reach out!"></textarea>
  </div>
  <div class=betweenRow>
    <span *ngIf="autoReplies?.length > 0"><strong>Your Common Replies</strong></span>
</div>

  <div class=centerColumn>
    <div *ngFor="let reply of autoReplies; trackBy: tracked" class=ar-tile [@item] >
       <span *ngIf="!selectedAutoReply" (click)="setSelectedAutoReply(reply)" class=arbody>{{reply?.body | limit : 60}}<strong>{{reply?.body?.length > 60 ? "(More)" : ""}}</strong></span> 
       <span *ngIf="!!selectedAutoReply && reply.key == selectedAutoReply.key" class=arbody>{{selectedAutoReply?.body}}</span>
       <button *ngIf="!!selectedAutoReply && reply.key == selectedAutoReply.key" (click)="clearSelectedAutoReply()" mat-raised-button>Close</button>
       <button *ngIf="!selectedAutoReply" mat-raised-button color="warn" (click)="deleteReply(reply)">Delete</button>
    </div>
  </div>
</div>


<div  *ngIf="currentState != 'void'" [@trigger]=currentState  >
  <div class="horizaontalFlex" style="margin-top: 30px">
  
  

  <button 
    *ngIf="authLevel && autoReplyTrigger != 'void'" 
    [@auto]=autoReplyTrigger  
    mat-raised-button  
    class="accentButton"
    (click)="createNewAutoReply()">Save</button>

  <button 
    [ngClass]="{'accentButton': autoReplyTrigger != 'void'}"
    *ngIf="authLevel" 
    mat-raised-button 
    (click)="toggleAutoReplyTrigger()">{{autoReplyTrigger === "void" ? 'Manage Common Replies': 'Done'}}</button>

  <!-- <div *ngIf="authLevel" class="button youClaimed" (click)="toggleAutoReplyTrigger()"><span></span></div> -->
  <h2 *ngIf="authLevel == 'admin' && autoReplyTrigger === 'void'">{{entityId}}</h2>
  <h2 *ngIf="autoReplyTrigger === 'void'">{{profile?.firstname | titlecase}} {{profile?.lastname | titlecase}}</h2>
  </div>







  <div class="horizontalLine"></div>
  <h2 *ngIf="autoReplyTrigger === 'void'">{{order}}</h2>
  <div class="container" *ngIf="autoReplyTrigger === 'void'">
  <div class="col1">
    <div class="filterContainer">      
      <div *ngIf="authLevel && unclaimed > 0" 
        class="flexFilter button4 unclaimedIndicator" [ngClass]="{'unclaimedButton': _order === 'Unclaimed'}" 
        (click)="showUnclaimed()">Unclaimed&nbsp;&nbsp;<div class="limit button5 unclaimedIndicator">{{unclaimed}}</div></div>

      <span *ngIf="authLevel" class="filter button" [ngClass]="{'selectedFilter': _order === 'Name'}" (click)="orderByName()">Name</span>
      <div class="flexFilter ffstyle button" [ngClass]="{'selectedFilter': _order === 'Date'}" (click)="orderByDate()" > 
          Date&nbsp;&nbsp;
          <div (click)="toggleDateFilter($event)" style="margin:0;padding:0" class="limit button limit2"> 
            <span  *ngIf="ascending == 'desc'">&uarr;</span>
            <span  *ngIf="ascending == 'asc'">&darr;</span>
          </div>
      </div>
      <span *ngIf="authLevel" class="filter button" [ngClass]="{'selectedFilter': _order === 'Instructor'}" (click)="orderByInstructor()">Instructor</span>
      <span *ngIf="authLevel" class="filter button" [ngClass]="{'selectedFilter': _order === 'My Claims'}" (click)="orderByClaimed()">My Claims</span>
      <span *ngIf="authLevel" class="filter button" [ngClass]="{'selectedFilter': _order === 'New Users'}" (click)="orderBySystem()">New Users</span>
      <span *ngIf="needsReset" class="filter button" (click)="reset()">Reset</span>
     </div>
     <div class="horizontalLine under900"></div>

  </div> 
  <div class="col2">
    


<table 
  *ngIf="!!conversations && autoReplyTrigger === 'void'"
  mat-table 
  matSort
  [dataSource]="conversations" 
  class="mat-elevation-z8 smooth" 
  style="margin-left: 2%;margin-right: 2%; width: 96%">
    
  <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->
    <ng-container matColumnDef="read">
      <th mat-header-cell *matHeaderCellDef > <span style="display: flex;justify-content: center;"><strong>Read</strong></span>  </th>
      <td mat-cell *matCellDef="let conversation"> 
        <p *ngIf="unreadMessages && !unreadMessages[conversation.key] && conversation?.lastMessage?.read[profile?.uid] || !unreadMessages  && conversation?.lastMessage?.read[profile?.uid]"> 
          <!-- read -->
          <svg height="20" width="20">
              <circle cx="10" cy="10" r="10" stroke="#4A829B" stroke-width="1" fill="transparent" />
          </svg> 
        </p>
        <p *ngIf="unreadMessages && unreadMessages[conversation.key] || !conversation?.lastMessage?.read[profile?.uid]">
          <!-- unread -->
          <svg height="20" width="20">
            <circle cx="10" cy="10" r="10" stroke="#4A829B" stroke-width="1" fill="#4A829B" />
          </svg> 
        </p>
      </td>
    </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header > <span style="display: flex;justify-content: flex-start;"><strong>Name</strong></span> </th>
    <td mat-cell *matCellDef="let conversation"> 
      <div class="verticalFlex">
      <span class="name" *ngIf="conversation?.originalCreator?.key === profile?.uid && !authLevel">You</span>
      <span class="name" *ngIf="conversation?.originalCreator?.key !== profile?.uid && !authLevel">{{conversation?.originalCreator?.firstname}}</span>
      <span class=name *ngIf="!!authLevel"><strong>{{conversation?.originalCreator?.firstname | titlecase}}</strong></span>
      <span *ngIf="!!conversation?.resolved" class=repliedOutline>
        Answered
      </span>
      <span *ngIf="!conversation?.resolved" class=askedOutline>
        Not Answered
      </span>
    </div>
    </td>
  </ng-container>

    <!-- Instructor Column -->
    <ng-container matColumnDef="instructor">
      <th mat-header-cell *matHeaderCellDef mat-sort-header > <span style="display: flex;justify-content: center;"><strong>Instructor</strong></span>  </th>
      <td mat-cell *matCellDef="let conversation"> 
        <div class="verticalFlex">
          <span class="name" *ngIf="conversation?.instructor">{{profiles[conversation?.instructor]?.firstname}}</span>
          <span *ngIf="conversation?.forwarded"  [ngClass]="{'askedOutline': !conversation?.resolved, 'repliedOutline': !!conversation?.resolved}" >Forwarded</span>
        </div>
      </td>
    </ng-container>

    <!-- Message Column -->
    <ng-container matColumnDef="message" sticky="true">
      <th mat-header-cell *matHeaderCellDef>  <span style="display: flex;justify-content: center;"><strong>Message</strong></span> </th>
      <td mat-cell *matCellDef="let conversation"> 
        <p  *ngIf="conversation?.lastMessage?.message" >{{conversation.lastMessage.message | limit}}</p>
      </td>
    </ng-container>

  <!-- Date Column -->
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header > <span style="display: flex;justify-content: center;"><strong>Date</strong></span> </th>
    <td mat-cell *matCellDef="let conversation"> 
      <div class="dateContainer" *ngIf="conversation?.lastMessage?.date && reload ==='allMessages'" >
        <p class="longDate" >{{conversation.lastMessage.date | relativeDate}}</p>
        <p class="shortDate">{{conversation.lastMessage.date | relativeDate: true}}</p>
      </div>
    </td>
  </ng-container>

  <!-- Options -->
  <ng-container matColumnDef="more">
    <th mat-header-cell *matHeaderCellDef><span style="display: flex;justify-content: center;"><strong>More</strong></span> </th>
    <td mat-cell *matCellDef="let conversation">
      <button mat-stroked-button (click)="openBottomSheet($event, conversation)">:::::::</button>
    </td>

  </ng-container>

  <!-- Claimed Column -->
  <ng-container matColumnDef="claimed">
    <th mat-header-cell *matHeaderCellDef> <span style="display: flex;justify-content: center;"><strong>Claimed</strong></span>  </th>
    <td mat-cell *matCellDef="let conversation"> 
      <span *ngIf="authLevel" >
        <div *ngIf="conversation?.instructor === profile?.uid" class="youClaimed large" >You Claimed</div>
        <div *ngIf="conversation?.instructor !== profile?.uid && !!conversation?.instructor" class="claimed large" >Claimed</div>
        <div *ngIf="!conversation?.instructor" class="unclaimed large">Unclaimed</div>
        <div *ngIf="conversation?.instructor === profile?.uid" class="youClaimed small">C</div>
        <div *ngIf="conversation?.instructor !== profile?.uid && !!conversation?.instructor" class="claimed small">C</div>
        <div *ngIf="!conversation?.instructor" class="unclaimed small">U</div>
      </span>

    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row
    [@item]
    *matRowDef="let row; columns: displayedColumns;"  (click)="select(row)"
    [ngClass]="{'read': unreadMessages && !unreadMessages[row.key] && row?.lastMessage?.read[profile?.uid] || !unreadMessages  && row?.lastMessage?.read[profile?.uid] ,
    'unread': unreadMessages && unreadMessages[row.key] || !row?.lastMessage?.read[profile?.uid],
    'forwarded': !!row?.forwarded && !row?.resolved && !!authLevel}"
   ></tr>
</table>
<h1 style="color: lightgrey; text-align: center; " *ngIf="(conversations | async)?.length === 0 || !conversations">No Messages</h1>

  </div>
</div>
  

</div>